<template>
  <div ref="navbar" class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      style="padding-top: 2px"
      :click-fn="toggleSideBar"
    />
    <div
      :style="{
        float: 'left',
        width: width * 0.74 + 'px',
        'margin-top': '4px'
      }"
    >
      <notice />
    </div>
    <div ref="rightMenu" class="right-menu">
      <div v-if="aiUserInfoForm.aihelp && Number(aiUserInfoForm.aihelp) === 1" class="AiLogo" @click="openAi">
        <div class="AiLogo-item">
          <img src="@/assets/img/aiLogo.gif" alt="" class="aiLogo" />
          <span class="text">AI智能助手</span>
        </div>
      </div>

      <div class="ft14 right-menu-item mr10 cursor-p" @click="switchAccount()">
        {{ nameStr }}
        <el-tooltip :content="merchantName" placement="top" popper-class="tooltipNav">
          <i v-if="merchantName.split('-').length === 2" class="el-icon-question" style="color: #108ee9" />
        </el-tooltip>
        <span>（{{ taxSourceName }}）</span>
        <img src="@/assets/img/check.png" class="checkImg" />
      </div>
      <div class="right-menu-item cursor-p" @click="openNoticeDrawer">
        <img src="@/assets/img/index/notice-icon.png" class="w15 verAlign" />
        <el-badge :is-dot="isCheck" style="top: -5px; left: -6px" />
      </div>

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click" @command="handleCommand">
        <div class="avatar-wrapper">
          <div class="ft14">{{ fName }}</div>
          <i style="font-size: 100%; margin-top: -2px" class="el-icon-caret-bottom" />
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :command="1">修改登录密码</el-dropdown-item>
            <el-dropdown-item :command="2">修改支付密码</el-dropdown-item>
            <el-dropdown-item divided command="logout">
              <span style="display: block">退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <el-dialog
      :visible="dialogVisible"
      :title="putType === 1 ? '修改登录密码' : '修改支付密码'"
      width="500px"
      :before-close="handleClose"
      :modal="false"
      @close="close"
    >
      <div class="pl20 pr20">
        <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
          <el-tab-pane label="原密码修改" name="first">
            <el-form ref="queryParam1" :rules="rules" :model="queryParam" label-width="100px">
              <el-form-item label="原密码：" prop="oldPwd">
                <el-input
                  v-model="queryParam.oldPwd"
                  maxlength="40"
                  :placeholder="putType === 1 ? '请输入原登录密码' : '请输入原支付密码'"
                  show-password
                  @blur="queryParam.oldPwd = $event.target.value"
                />
              </el-form-item>
              <el-form-item label="新密码：" prop="newPwd">
                <el-input
                  v-model="queryParam.newPwd"
                  maxlength="40"
                  :placeholder="putType === 1 ? '请输入新登录密码' : '请输入新支付密码'"
                  show-password
                  @input="
                    filterInput($event, {
                      target: queryParam,
                      key: 'newPwd',
                      type: 'password'
                    })
                  "
                />
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="手机验证码修改" name="second">
            <el-form ref="queryParam" :model="queryParam" :rules="rules" label-width="100px">
              <el-form-item label="验证手机号：">
                <div class="ft14">{{ currPayMobile }}</div>
              </el-form-item>
              <el-form-item label="新密码：" prop="newPwd">
                <el-input
                  v-model="queryParam.newPwd"
                  maxlength="40"
                  :placeholder="putType === 1 ? '请输入新登录密码' : '请输入新支付密码'"
                  show-password
                  @input="
                    filterInput($event, {
                      target: queryParam,
                      key: 'newPwd',
                      type: 'password'
                    })
                  "
                />
              </el-form-item>
              <el-form-item label="验证码：" prop="verificationCode">
                <div class="rx-sc">
                  <el-input
                    v-model="queryParam.verificationCode"
                    class="mr10"
                    size="small"
                    placeholder="请输入验证码"
                    maxlength="6"
                  />
                  <el-button type="primary" size="small" :disabled="smsCodeBtnDisabled" @click="getCode">
                    <span v-if="!smsCodeBtnDisabled">发送验证码</span>
                    <span v-else class="sms-code-resend">{{ `重新发送 (${codeSeconds})` }}</span>
                  </el-button>
                </div>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleClose()">取消</el-button>
          <el-button type="primary" @click="confirm(activeName == 'first' ? 'queryParam1' : 'queryParam')">确认</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog :visible="switchVisible" title="选择公司" width="30%" :before-close="handleClose" :modal="false">
      <el-input
        v-model="searchMerchantName"
        class="ww100"
        placeholder="请输入公司名称搜索"
        prefix-icon="el-icon-search"
        @input="switchAccount()"
      />
      <div
        v-for="(item, index) of subAccountLi"
        :key="index"
        class="rx-ss pl15 pr15 pt15 pb15 cursor-p"
        :class="index != subAccountLi.length - 1 ? 'subAccount-item' : 'mb20'"
        @click="handleLogin(item)"
      >
        <div class="w50 h50 select-merchant-icon ta-c">
          <img
            :src="shellConst.iconPhoto || shellConst.websiteLogo || shellConst.systemPhoto"
            alt=""
            style="width: 50px; height: 50px; border-radius: 50%; object-fit: contain"
          />
        </div>
        <div class="ml10" style="max-width: 82%">
          <div class="ft16 fwb mb5">{{ item.merchantName }}</div>
          <div class="">服务商：{{ item.taxSourceName }}<span v-if="item.lastFlag" class="red">（上次登录）</span></div>
        </div>
      </div>
    </el-dialog>
    <el-drawer :visible="noticeDrawer" size="600px" :direction="direction" :before-close="noticeDrawerClose" :modal="false">
      <div class="pt20 pb20 pl20 pr10">
        <el-tabs v-model="drawerActive">
          <el-tab-pane label="通知" name="1">
            <div v-if="noticeList.length > 0" class="cx-ss" style="height: calc(100vh - 96px)">
              <div class="ww100 flex1" style="overflow: auto">
                <div
                  v-for="(item, index) in noticeList"
                  :key="index"
                  class="notice-list ft14 pb25 pr15"
                  :class="index === 0 ? '' : 'pt25 bd-top'"
                >
                  <div class="rx-bc">
                    <div class="flex1">
                      <span>{{ item.noticeTheme }}</span>
                      <span class="color-999 ml15">
                        <el-badge :is-dot="item.isCheck === 1">
                          {{ item.currentlyInStatusName }}
                        </el-badge>
                      </span>
                    </div>
                    <div class="color-999 ml20">
                      {{ item.currentlyNoticeOrderNoTime }}
                    </div>
                  </div>
                  <div class="rx-bs mt15">
                    <div class="color-666 flex1">{{ item.noticeDetails }}</div>
                    <div
                      v-if="item.noticeOrderType === 1 || item.noticeOrderType === 2 || item.noticeOrderType === 3"
                      class="color-0069FF cursor-p ml10 rx-sc"
                      @click="goDetail(item)"
                    >
                      查看详情<i class="el-icon-arrow-right ft16" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="ta-r mt10 rx-sc ww100 bg-fff">
                <div class="ft13" style="color: #606266">共 {{ total }} 条</div>
                <el-pagination
                  background
                  :current-page="noticeParam.page"
                  :page-size="noticeParam.size"
                  :pager-count="5"
                  layout=" prev, pager, next, jumper"
                  :total="total"
                  @current-change="handleCurrentChange"
                />
              </div>
            </div>
            <div v-if="noticeList.length <= 0" class="rx-cc hh100">
              <div class="ta-c">
                <img src="@/assets/img/no-notice-img.png" class="w250 mb5" />
                <div>暂无通知</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="平台公告" name="2">
            <div v-if="publicList.length !== 0">
              <div
                v-for="(item, index) in publicList"
                :key="index"
                class="notice-list ft14 pb25 pr15"
                :class="index === 0 ? '' : 'pt25 bd-top'"
                @click="show(index)"
              >
                <div class="color-666 notice" :style="{ '-webkit-line-clamp': item.line }" style="white-space: pre-wrap">
                  {{ item.text }}
                </div>
                <div class="rx-bs mt10 color-999">
                  <div>{{ item.updateTime }}</div>
                  <div class="rx-ec">
                    {{ item.line === 2 ? "展开" : "收起" }}
                    <i :class="item.line === 2 ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" class="ft10" />
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="ft14 color-666 ta-c mb30">暂无公告</div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
    <ai-iframe v-show="iframeShow" ref="AIIFrameParent" :ai-user-info-form="aiUserInfoForm" :src="iframeSrc" class="AIIFrame" />
  </div>
</template>

<script>
import notice from "../../views/dashboard/editor/components/notice";
import { mapGetters } from "vuex";
import Hamburger from "@/components/Hamburger";
import AiIframe from "@/components/AiIframe";
import { getSystemNoticeList, isCkeckNoticet } from "@/api/navbar";
import { getPayMobile, getSwitchAccount, putLoginPwd, putPayPwd } from "../../api/profile";
import { publicAdministration } from "@/api/statistics";
import { aiUserInfo } from "@/api/user";
import { getCode } from "@/api/distributeLeaflets";

export default {
  components: {
    Hamburger,
    notice,
    AiIframe
  },
  data() {
    return {
      iframeSrc: process.env.VUE_APP_IFRAME_SRC,
      iframeShow: false,
      width: 0,
      merchantName: localStorage.getItem("merchantName"),
      taxSourceName: localStorage.getItem("taxSourceName"),
      fId: localStorage.getItem("fId"),
      fName: localStorage.getItem("fName"),
      fToken: localStorage.getItem("fToken"),
      switchVisible: false,
      subAccountLi: [],
      putType: 1,
      codeSeconds: 0, // 验证码发送时间间隔
      dialogVisible: false,
      aiUserInfoForm: {},
      queryParam: {
        oldPwd: "",
        newPwd: "",
        verificationCode: ""
      },
      activeName: "first", // 修改密码方式
      currPayMobile: "",
      oldPwdType: "password",
      newPwdType: "password",
      direction: "rtl",
      noticeDrawer: false,
      noticeParam: {
        page: 1,
        size: 10
      },
      noticeList: [],
      total: 0,
      isCheck: false, // 是否有红点
      searchMerchantName: "",
      smsCodeBtnDisabled: false, // 验证码
      publicList: [],
      drawerActive: "1"
    };
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "device"]),
    nameStr() {
      if (this.merchantName.split("-").length === 2) {
        return this.merchantName.split("-")[0];
      }
      return this.merchantName;
    },
    shellConst() {
      return this.$store.state.domain.shellConst;
    },
    rules() {
      return {
        oldPwd: [
          {
            required: true,
            message: this.putType === 1 ? "请输入原登录密码" : "请输入原支付密码"
          }
        ],
        newPwd: [
          {
            required: true,
            message: this.putType === 1 ? "请输入新登录密码" : "请输入新支付密码",
            trigger: "change"
          },
          { min: 8, max: 40, message: "长度在 8 到 40 位", trigger: "change" },
          this.$formRules.password
        ],
        verificationCode: [{ required: true, message: "请输入验证码" }]
      };
    }
  },
  watch: {
    $route: {
      handler(val, oldval) {
        if (val.name !== oldval.name) {
          // 路由变化
          this.noticeDrawerClose();
          this.handleClose();
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  async mounted() {
    await this._aiUserInfo();
    const navbar = this.$refs.navbar;
    const rightMenu = this.$refs.rightMenu;
    if (navbar && rightMenu) this.width = navbar.offsetWidth - rightMenu.offsetWidth;
    window.addEventListener("resize", () => {
      const nav = this.$refs.navbar;
      const right = this.$refs.rightMenu;
      if (!nav || !right) return;
      this.width = nav.offsetWidth - right.offsetWidth;
    });
    this.getIsCkeckNotice();
    this.publicAdministrations();
    window.addEventListener("message", event => {
      if (event.data.type === "closeIframeDialog") {
        this.iframeShow = false;
      }
    });
  },
  methods: {
    handleCommand(v) {
      if (v === 1 || v === 2) {
        this.putPassword(v);
      } else {
        this.logout();
      }
    },
    async _aiUserInfo() {
      const res = await aiUserInfo({ merchantDomain: window.location.host });
      if (res.code === 200) {
        this.aiUserInfoForm = res.data;
      }
    },
    // 获取公告列表
    publicAdministrations() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(225, 225, 225, 0.7)"
      });
      publicAdministration({})
        .then(res => {
          for (let i = 0; i < res.data.length; i++) {
            const obj = {};
            obj.text = res.data[i].content;
            obj.updateTime = res.data[i].updateTime;
            obj.line = 2;
            this.publicList.push(obj);
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    // 点击公告的展示更多
    show(index) {
      if (this.publicList[index].line === 2) {
        this.publicList[index].line = 100;
      } else {
        this.publicList[index].line = 2;
      }
    },
    // 获取验证码
    getCode() {
      this.handleSmsCodeTime(59);
      this.smsCodeBtnDisabled = true;
      getCode()
        .then(() => {})
        .catch(() => {
          this.smsCodeBtnDisabled = false;
          this.handleSmsCodeTime(0);
        });
    },
    handleSmsCodeTime(time) {
      this.codeSeconds = 60;
      this.timer = setInterval(() => {
        if (time === 0) {
          clearInterval(this.timer);
          this.smsCodeBtnDisabled = false;
        } else {
          this.codeSeconds = time;
          this.smsCodeBtnDisabled = true;
          time--;
        }
      }, 1000);
    },
    handleClick() {
      this.queryParam.oldPwd = null;
      this.queryParam.newPwd = null;
      this.queryParam.password = null;
      this.queryParam.verificationCode = null;
      this.close();
    },
    // 修改密码弹框的关闭
    close() {
      if (this.$refs.queryParam1) {
        this.$refs.queryParam1.resetFields();
      }
      if (this.$refs.queryParam) {
        this.$refs.queryParam.resetFields();
      }
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    logout(value) {
      // removeToken()
      if (value === 1) {
        this.$store
          .dispatch("user/logout")
          .then(() => {
            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.$confirm("是否确定退出登录？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$store
            .dispatch("user/logout")
            .then(() => {
              this.$router.push(`/login?redirect=${this.$route.fullPath}`);
              localStorage.removeItem("docking");
              localStorage.removeItem("invoicing");
              localStorage.removeItem("beiSenOutApiConfig");
            })
            .catch(() => {
              this.loading = false;
            });
        });
      }
    },
    putPassword(type) {
      this.dialogVisible = true;
      this.putType = type;
      if (this.currPayMobile === "") {
        getPayMobile().then(res => {
          this.currPayMobile = res.data;
        });
      }
    },
    switchAccount() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(225, 225, 225, 0.7)"
      });
      getSwitchAccount({ id: this.fId, merchantName: this.searchMerchantName })
        .then(res => {
          this.subAccountLi = res.data.batchImportRecordDTOList;
          this.switchVisible = true;
        })
        .finally(() => {
          loading.close();
        });
      this.switchVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.switchVisible = false;
    },
    confirm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(225, 225, 225, 0.7)"
          });
          if (this.putType === 1) {
            putLoginPwd({
              password: this.queryParam.oldPwd,
              newPassword: this.queryParam.newPwd,
              verificationCode: this.queryParam.verificationCode
            })
              .then(() => {
                this.$message({
                  message: "密码修改成功",
                  type: "success"
                });
                this.logout(1);
              })
              .catch(() => {})
              .finally(() => {
                loading.close();
              });
          } else {
            putPayPwd({
              payPassword: this.queryParam.oldPwd,
              newPayPassword: this.queryParam.newPwd,
              verificationCode: this.queryParam.verificationCode
            })
              .then(() => {
                this.$message({
                  message: "支付密码修改成功",
                  type: "success"
                });
                this.dialogVisible = false;
              })
              .catch(() => {})
              .finally(() => {
                loading.close();
              });
          }
        } else {
          return false;
        }
      });
    },
    handleLogin(data) {
      this.loading = false;
      this.$store
        .dispatch("user/login", {
          id: this.fId,
          username: this.fName,
          token: this.fToken,
          merchantId: data.merchantId,
          taxSourceId: data.taxSourceId,
          agreementId: data.agreementId,
          userId: data.id
        })
        .then(() => {
          this.searchMerchantName = "";
          this.$message({
            message: "切换成功",
            type: "success"
          });
          location.reload();
          localStorage.setItem("notice", "open");
        })
        .catch(() => {
          this.switchVisible = false;
        });
    },
    openNoticeDrawer() {
      this.noticeParam = {
        page: 1,
        size: 10
      };
      this.noticeList = [];
      this.getSystemNoticeList();
      setTimeout(this.getIsCkeckNotice(), 2000);
    },
    getSystemNoticeList() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(225, 225, 225, 0.7)"
      });
      getSystemNoticeList(this.noticeParam)
        .then(res => {
          this.noticeList = res.data;
          this.total = res.total;
          loading.close();
          this.noticeDrawer = true;
        })
        .catch(() => {
          loading.close();
        });
    },
    handleCurrentChange(val) {
      // 切换分页
      this.noticeParam.page = val;
      this.getSystemNoticeList();
    },
    // 查看详情
    goDetail(item) {
      if (item.noticeOrderType === 3) {
        if (window.location.hash.split("?")[0] === "#/distribution/index") {
          this.$router.push({
            name: `DistributionDetails`,
            query: { batchSettlementOrderNo: item.currentlyNoticeOrderNo }
          });
          location.reload();
        } else {
          this.$router.push({
            name: `DistributionDetails`,
            query: { batchSettlementOrderNo: item.currentlyNoticeOrderNo }
          });
        }
      }
      if (item.noticeOrderType === 1) {
        if (window.location.hash.split("?")[0] === "#/flexibleuser/importDetail") {
          this.$router.push({
            path: `/flexibleuser/importDetail`,
            query: { id: item.currentlyNoticeOrderNo }
          });
          location.reload();
        } else {
          this.$router.push({
            path: `/flexibleuser/importDetail`,
            query: { id: item.currentlyNoticeOrderNo }
          });
        }
      }
      if (item.noticeOrderType === 2) {
        if (window.location.hash.split("?")[0] === "#/applyInvoicing/details") {
          this.$router.push({
            path: `/applyInvoicing/details`,
            query: { id: item.currentlyNoticeOrderNo }
          });
          location.reload();
        } else {
          this.$router.push({
            path: `/applyInvoicing/details`,
            query: { id: item.currentlyNoticeOrderNo }
          });
        }
      }
    },
    getIsCkeckNotice() {
      isCkeckNoticet()
        .then(res => {
          this.isCheck = !!(res.data && res.data > 0);
        })
        .catch(() => {});
    },
    noticeDrawerClose() {
      this.getIsCkeckNotice();
      this.noticeDrawer = false;
    },
    openAi() {
      this.iframeShow = !this.iframeShow;
      this.$nextTick(() => {
        // const iframe = this.$refs.AIIFrameParent.$refs.AIIFrame
        if (this.$refs.AIIFrameParent) {
          this.$refs.AIIFrameParent.onIframeLoad();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.checkImg {
  width: 14px;
  vertical-align: middle;
  margin-top: -2px;
}

.navbar {
  height: 74px;
  overflow: hidden;
  position: relative;
  background: #fff;
  padding: 12px 0 11px 0;
  border-bottom: 1px solid #ebeef5;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;
    .AiLogo {
      margin-right: 30px;
      box-sizing: border-box;
      height: 35px;
      overflow: hidden;
      width: 140px;
      box-sizing: border-box;
      border: 0.5px solid rgb(235 225 225);
      border-radius: 8px;
      .AiLogo-item {
        height: 35px;
        display: flex;
        align-items: center;
        padding-left: 5px;
        box-sizing: border-box;
        cursor: pointer;
        .aiLogo {
          height: 30px;
          margin-top: -2px;
          margin-right: 7px;
        }
        .text {
          height: 23px;
          line-height: 23px;
          color: rgba(0, 104, 255, 1);
          font-size: 16px;
          font-family: YSBiaoTiHei-regular;
          font-style: italic;
          font-weight: 600;
        }
      }
    }

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      // font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        // margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 20px;
          font-size: 12px;
        }
      }
    }
  }

  ::v-deep .el-dialog {
    .el-dialog__body {
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  .subAccount-item {
    border-bottom: 1px solid #eee;
  }

  .select-merchant-icon {
    color: #fff;
    border-radius: 50%;
    font-size: 10px;
    font-weight: 500;
  }

  ::v-deep .el-drawer__header {
    display: none;
  }

  ::v-deep.el-tabs__item:focus.is-active.is-focus {
    box-shadow: none;
  }

  .notice {
    line-height: 23px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    letter-spacing: 0.5px;
    cursor: default;
  }
}
</style>

<style lang="scss">
.tooltipNav {
  color: white !important;
  background: #108ee9 !important;
  .popper__arrow {
    border-bottom-color: #108ee9 !important;
    &::after {
      border-bottom-color: #108ee9 !important;
    }
  }
}
</style>
